<div class="container-fluid p-0">
  <div class="row g-0">
    <div class="col-xl-3">
      <!--<div class="auth-full-bg pt-lg-5 p-4">
      <div class="w-100">-->
      <div class="bg-overlay" style="background: url(../../assets/Layout/images/Freelancer.jpg) no-repeat !important;"></div>

      <!--</div>
      </div>-->
    </div>
    <div id="LoadingImage">
      <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading Image" />
    </div>
    <span id="btnCountry" class="" (click)="GetState()" style="display:none"></span>
    <span id="btnState" class="" (click)="GetCity()" style="display:none"></span>
    <div class="col-xl-9">
      <div class="auth-full-page-content p-3">
        <div class="w-100">
          <div class="d-flex flex-column h-100">
            <div class="mb-4 mb-md-5">
              <div class="row g-0" style="text-align:center">
                <div class="col-xl-10 p-1">
                  <h1 style="color:darkblue">Freelancer Onboarding Form</h1>
                  <p class="text-muted">Thank you for choosing us. Please enter your details for further communication.</p>
                </div>
                <div class="col-xl-2">
                  <a class="d-block auth-logo">
                    <img src="../../assets/Layout/images/NTLogo.png" alt="" height="60" class="auth-logo-dark">
                  </a>
                </div>

              </div>
              <div class="row g-0 col-12" id="cardInfo" style="height:42%; overflow-y:scroll;">
                <div class="container">
                  <div class="card" style="padding-left:3rem !important;padding-right:3rem !important;padding-top:1rem !important;padding-bottom:0rem !important; box-shadow:none !important">
                    <div class="card-body">
                      <div class="form-group">
                        <h5 style="background-color: #d3d3d340">Enter personal information!</h5>
                        <br />
                        <div class="row form-group">
                          <div class="col-sm-4">
                            First Name<em>*</em>
                            <input id="Txt_Name" type="text" class="form-control skipSpecialChar" maxlength="40" autocomplete="off" />
                          </div>
                          <div class="col-sm-4">
                            Middle Name
                            <input id="Txt_MiddleName" type="text" class="form-control skipSpecialChar" maxlength="40" autocomplete="off" />
                          </div>
                          <div class="col-sm-4">
                            Last Name<em>*</em>
                            <input id="Txt_LastName" type="text" class="form-control skipSpecialChar" maxlength="40" autocomplete="off" />
                          </div>

                        </div>
                        <div class="row form-group">
                          <!--<div class="col-sm-6">
                            Microsoft Team Id
                            <input id="Txt_TeamID" type="text" class="form-control " maxlength="40" autocomplete="off" (change)="emailIdOnly($event)" />
                          </div>-->
                          <div class="col-sm-6">
                            Email ID<em>*</em>
                            <input id="Txt_EmailID" type="text" class="form-control" maxlength="40" autocomplete="off" (change)="onSearchChange($event)" />
                          </div>
                          <div class="col-sm-6">
                            Alternate Email ID
                            <input type="text" class="form-control" id="Txt_AltEmailID" maxlength="40" autocomplete="off" (change)="emailIdOnly($event)" />
                          </div>
                        </div>
                        <div class="row form-group">
                          <div class="col-sm-3">
                            Work Type<em>*</em>
                            <select class="form-control" id="ddlTOW">
                              <option value="">Select</option>
                              <option value="Full time">Full time</option>
                              <option value="Part time">Part time</option>
                            </select>
                          </div>
                          <div class="col-sm-3">
                            Mobile No.<em>*</em>
                            <input type="text" id="Txt_mobile" class="form-control IsNumeric" (change)="numbervalidate($event)" maxlength="10" autocomplete="off">
                          </div>
                          <div class="col-sm-3">
                            DOB<em>*</em>
                            <input type="date" name="DOB" class="form-control float-right" id="Txt_DOB" autocomplete="off" (change)="Dobdatevalidation($event)">
                          </div>
                          <div class="col-sm-3">
                            Gender<em>*</em>
                            <select class="form-control" id="ddlGender">
                              <option value="">Select</option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                            </select>
                          </div>
                        </div>
                        <div class="row form-group">
                          <div class="col-sm-12">
                            Address<em>*</em>
                            <input type="text" id="Txt_address" class="form-control" autocomplete="off">
                          </div>

                        </div>
                        <div class="row form-group">
                          <!--<div class="col-sm-3">
                            City<em>*</em>
                            <input type="text" id="ddlCity" class="form-control" maxlength="40" autocomplete="off" />

                          </div>
                          <div class="col-sm-3">
                            State<em>*</em>
                            <input type="text" id="ddlState" class="form-control" maxlength="40" autocomplete="off" />

                          </div>-->
                          <div class="col-sm-3">
                            Country<em>*</em>
                            <select class="form-control" id="ddlCountry">
                              <option value="0">Select Country</option>
                              <option *ngFor="let itemC of CountryList" value={{itemC.ID}}>{{itemC.CountryName}}</option>
                            </select>
                          </div>
                          <div class="col-sm-3">
                            State<em>*</em>
                            <select class="form-control" id="ddlState">
                              <option value="0" disabled selected>Select State</option>
                              <option *ngFor="let itemS of StateList" value={{itemS.ID}} [selected]="itemS.ID==StateIDPop">{{itemS.StateName}}</option>
                            </select>
                          </div>
                          <div class="col-sm-3">
                            City<em>*</em>
                            <select class="form-control" id="ddlCity">
                              <option value="0" disabled selected>Select City</option>
                              <option *ngFor="let itemCT of CityList" value={{itemCT.ID}} [selected]="itemCT.ID==CityIDPop">{{itemCT.CityName}}</option>
                            </select>
                          </div>
                          <div class="col-sm-3">
                            Pincode<em>*</em>
                            <input type="text" class="form-control IsNumeric" id="Txt_pincode" maxlength="6" autocomplete="off" />
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>

                  <div class="card" style="padding-left:3rem !important;padding-right:3rem !important;padding-top:0rem !important;padding-bottom:0rem !important;box-shadow:none">
                    <div class="card-body">
                      <div class="form-group">
                        <h5 style="background-color: #d3d3d340">Enter service information!</h5>
                        <br />
                        <div class="row form-group">
                          <div class="col-sm-12">
                            CategoryList<em>*</em>
                            <select id="ddlcategory" class="form-control" multiple>
                              <option *ngFor="let item of CategoryList" value={{item.ID}}>
                                {{item.TaskName}}
                              </option>
                            </select>
                          </div>

                        </div>
                        <div class="row form-group">
                          <div class="col-sm-6">
                            Source<em>*</em>
                            <select id="ddlSourceList" class="form-control" multiple>
                              <option *ngFor="let item of sourceList" value={{item.ID}}>
                                {{item.SourceName}}
                              </option>
                            </select>
                          </div>
                          <div class="col-sm-6">
                            Languages<em>*</em>
                            <select id="ddlLanguageList" class="form-control" multiple>
                              <option *ngFor="let item of languageList" value={{item.ID}}>
                                {{item.Language}}
                              </option>
                            </select>
                          </div>

                        </div>


                        <div class="row form-group">
                          <div class="col-sm-6">
                            Interest<em>*</em>
                            <select id="ddlInterestList" class="form-control" multiple>
                              <option *ngFor="let item of interestList" value={{item.ID}}>
                                {{item.Subject}}
                              </option>
                            </select>
                          </div>
                          <div class="col-sm-6">
                            Restriction<em>*</em>
                            <select id="ddlRestrictionList" class="form-control" multiple>
                              <option *ngFor="let item of restrictionList" value={{item.ID}}>
                                {{item.Subject}}
                              </option>
                            </select>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card" style="padding-left:3rem !important;padding-right:3rem !important;padding-top:0rem !important;padding-bottom:0rem !important;box-shadow:none">
                    <div class="card-body">
                      <div class="form-group">
                        <h5 style="background-color: #d3d3d340">Bank details!</h5>
                        <br />
                        <div class="row form-group">

                          <div class="col-sm-4">
                            Bank Name
                            <input type="text" class="form-control" id="Txt_BankName" />
                          </div>
                          <div class="col-sm-4">
                            Account No.
                            <input type="text" class="form-control IsNumeric" id="Txt_AccNo" />
                          </div>
                          <div class="col-sm-4">
                            IFSC Code
                            <input type="text" class="form-control" id="Txt_IFSC" />
                          </div>

                        </div>
                        <div class="row form-group">

                          <div class="col-sm-4">
                            Branch Name
                            <input type="text" class="form-control" id="Txt_Branch" />
                          </div>
                          <div class="col-sm-4">
                            NDA Document
                            <select class="form-control" id="ddlNDAdoc">
                              <option value="0" selected disabled>Select</option>
                              <option value="Signed">Signed</option>
                              <option value="UnSigned">UnSigned</option>
                              <option value="NoNeed">NoNeed</option>
                            </select>
                          </div>
                          <div class="col-sm-4">
                            PAN Card
                            <input type="text" class="form-control" id="Txt_PAN" />
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="card" style="padding-left:3rem !important;padding-right:3rem !important;padding-top:0rem !important;padding-bottom:0rem !important; box-shadow:none">
                    <div class="card-body">
                      <div class="form-group">
                        <h5 style="background-color: #d3d3d340">Resume/Photo upload!</h5>
                        <br />
                        <div class="row form-group">
                          <div class="col-sm-8 " id="fileupload">
                            Resume<em>*</em>
                            <input id="doc_file" type="file" class="form-control" (change)="onFileSelected($event)">
                            File size must be 50KB :('doc', 'docx', 'pdf')
                            <br /><br />
                            Additional Information
                            <textarea class="form-control" id="Txt_Notes" autocomplete="off"></textarea>
                          </div>
                          <div class="col-sm-4">
                            <div class="input-group" style="text-align:center;">
                              <img src="../../../assets/Images/userLogo.jpg" alt="Profile" style="height:110px;width:110px;margin-top:10px;border-radius:10px;" id="imgProfile" (error)="onerrorImageLoad()" /> <br /><br />
                              <input type="file" name="file" id="imageUploadForm" style="width: 100%;margin-left:10px" class="btn" (change)="showPreview($event)" />

                            </div>
                          </div>
                        </div>



                      </div>
                    </div>
                  </div>

                  <div class="modal-footer">

                    <button class="btn btn-primary waves-effect waves-light" type="submit" (click)="AddFreelancer()">Submit</button>

                  </div>
                </div>
              </div>
              <div class="text-center">
                <p class="mb-0">
                  © 2024 Sesame by Novatechset
                </p>
              </div>
            </div>


          </div>
        </div>
      </div>

    </div>
  </div>



</div>

<!--<div class="col" id="divFreelacner" >
  <div class="container">
    <div class="card" style="background-image: url('/ClientApp/src/app/Freelancer/register/ewan-robertson-fDsCIIGdw9g-unsplash.jpg');">
      <div class="card-body">
        <div class="modal-body" style="overflow-x:scroll">
          -Freelancer form title
          <div class="card">
            <div class="row align-items-center">
              <div class="col-md-4">
                <span class="logo-lg" style="float:left">
                  <img src="assets/Layout/images/logo-light.png" alt="" height="60">
                </span>
              </div>
              <div class="col-md-8">
                <strong id="Formtitle" style="font-size:x-large"> Freelancer Register</strong>
                <strong id="Formproofing" style="display:none;font-size:x-large"> Freelancer Proofing</strong>
              </div>
            </div>
          </div>

          <ul class="nav nav-tabs nav-tabs-custom" id="ULTabul">
            <li class="nav-item"><a class="nav-link active" data-toggle="tab" href="#divTesttab">Test Details</a></li>
            <li class="nav-item"><a class="nav-link" data-toggle="tab" href="#divPrimary">Primary</a></li>
          </ul><br />

          <div class="tab-content">
            <div class="tab-pane active" id="divTesttab">
              <div class="container">
                <div class="card" id="template" style="padding-top:10px;">
                  <h3> <strong>Dear  </strong>{{vendorname}}</h3> <br />
                  card-body
                  <div class="card-body" id="templatebody" style="padding-right:20px;padding-left:20px;">
                    <div id="para1" align="center">
                      Please access your proofs by clicking ‘Download’. If you have any difficulty downloading the files, please contact  <a href="mailto:@ContactEmail" target="_top">@ContactEmail</a>
                      You can access your proof by clicking the ‘Download PDF Proof’ button. If you have any difficulty downloading your file, please contact <a href="mailto:@ContactEmail" target="_top">@ContactEmail</a>
                    </div>
                    <div id="dtn_downloadpdf" align="center" style="padding:20px">
                      <button class="btn" id="testfiledownload" (click)="testfiledownload()"><i class="fa fa-download"></i> Download Proof </button>
                    </div>
                    <div align="center">
                      <span id="para2">
                        Please open your proofs, correct the PDF of your article using the Adobe Commenting tools, and then save the file. Only 1 file can be uploaded, so if you would like to send us more than 1 file (e.g. if you have replacement figure or table files), please zip/compress the files into a single file and then upload.
                      </span>
                      <span id="para3">
                        Please correct the PDF proof using the Comment and Markup Tools and then save the file to your device.<br /> To return your corrections click the ‘Upload’ button and select the corrected file for upload.<br /> Only one file can be uploaded into the system, however, if you need to send us more than one file please zip/compress the files into a single file and then upload.
                      </span>
                    </div>
                    Upload submit File
                    <div align="center" id="testfileuploadbtn" style="padding: 20px;">
                      <input #fileInput type="file" (change)="onuploadSelected($event)" id="doc_testuploadfile" /><br />
                      File size must be 50MB :('doc', 'docx', 'pdf')<br /><br />
                      <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnupload" (click)="confirmation()"><i class="fa fa-upload"></i> Upload</button>
                      <button id="testfileupload" (click)="testfileupload()" style="display:none"></button>
                    </div>
                    <div id="dtn_dwnfreelancerdownload" align="center" style="padding:20px">
                      <button class="btn" id="" (click)="freelanceruploadfiledownload()"><i class="fa fa-download"></i> Download copyright</button>
                    </div>
                    <div align="center">
                      <span id="para4">
                        If you do not have any corrections, please click ‘Approve proof without corrections’. Please note that by clicking this you are approving the proof, and you will not be allowed to upload additional files or text.
                      </span>
                      <span id="para5">
                        If you do not have any corrections, please click ‘Approve proof without corrections’. Please note that by clicking this you are approving the proof, and you will not be allowed to upload additional files or text.
                      </span>
                    </div>
                    <div align="center">
                      The Proof Correction System is compatible with IE, Firefox, Chrome, Opera and Safari.
                    </div>
                    <div class="card-footer">
                      <div>
                        <strong>Copyright &copy; 2023 <a href="#">Sesame WMS</a></strong>
                        All rights reserved.
                        <div class="float-right d-none d-sm-inline-block">
                          Novatechset
                        </div>
                      </div>
                    </div>
                  </div>
                  card-body end
                </div>
              </div>
            </div>
            end
            <div id="divPrimary" class="tab-pane">
              <div class="container">
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-4">
                      Name<em>*</em>
                      <input id="Txt_Name" type="text" class="form-control skipSpecialChar" maxlength="40" autocomplete="off" />
                    </div>
                    <div class="col-sm-4">
                      Email ID<em>*</em>
                      <input id="Txt_EmailID" type="text" class="form-control" maxlength="40" autocomplete="off" (change)="onSearchChange($event)" />
                    </div>
                    <div class="col-sm-4">
                      Microsoft Team Id
                      <input id="Txt_TeamID" type="text" class="form-control " maxlength="40" autocomplete="off" (change)="emailIdOnly($event)" />
                    </div>
                  </div>

                </div>

                <div class="row">
                  <div class="col-sm-8">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-sm-4">
                          Alternate Email ID
                          <input type="text" class="form-control" id="Txt_AltEmailID" maxlength="40" autocomplete="off" (change)="emailIdOnly($event)" />
                        </div>
                        <div class="col-sm-4">
                          Mobile No.<em>*</em>
                          <input type="text" id="Txt_mobile" class="form-control IsNumeric" (change)="numbervalidate($event)" maxlength="10" autocomplete="off">
                        </div>
                        <div class="col-sm-4">
                          DOB<em>*</em>
                          <input type="date" name="DOB" class="form-control float-right" id="Txt_DOB" autocomplete="off" (change)="Dobdatevalidation($event)">
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="row">
                          <div class="col-sm-4">
                            Gender<em>*</em>
                            <select class="form-control" id="ddlGender">
                              <option value="0" selected disabled>Select</option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                            </select>
                          </div>

                          <div class="col-sm-4">
                            Address<em>*</em>
                            <textarea class="form-control" id="Txt_address" autocomplete="off"></textarea>
                          </div>
                          <div class="col-sm-4">
                            Pincode<em>*</em>
                            <input type="text" class="form-control IsNumeric" id="Txt_pincode" maxlength="6" autocomplete="off" />
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="row">
                          <div class="col-sm-3">
                            Country<em>*</em>
                            <select class="form-control" id="ddlCountry" (change)="GetState(0)">
                              <option value="0" disabled selected>Select Country</option>
                              <option *ngFor="let itemC of CountryList" value={{itemC.ID}}>{{itemC.CountryName}}</option>
                            </select>
                          </div>
                          <div class="col-sm-3">
                            State<em>*</em>
                            <select class="form-control" id="ddlState" (change)="GetCity(0,0)">
                              <option value="0" disabled selected>Select State</option>
                              <option *ngFor="let itemS of StateList" value={{itemS.ID}} [selected]="itemS.ID==StateIDPop">{{itemS.StateName}}</option>
                            </select>
                          </div>
                          <div class="col-sm-3">
                            City<em>*</em>
                            <select class="form-control" id="ddlCity">
                              <option value="0" disabled selected>Select City</option>
                              <option *ngFor="let itemCT of CityList" value={{itemCT.ID}} [selected]="itemCT.ID==CityIDPop">{{itemCT.CityName}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                  profile
                  <div class="col-sm-4">
                    <div class="input-group" style="text-align:center;">
                      <img src="../../../assets/Images/userLogo.jpg" alt="Profile" style="height:110px;width:110px;margin-top:10px;border-radius:10px;" id="imgProfile" (error)="onerrorImageLoad()" /> <br /><br />
                      <input type="file" name="file" id="imageUploadForm" style="width: 100%;margin-left:10px" class="btn" (change)="showPreview($event)" />

                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    Source<em>*</em>
                    <select id="ddlSourceList" class="form-control" multiple>
                      <option *ngFor="let item of sourceList" value={{item.ID}}>
                        {{item.SourceName}}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-6">
                    Languages<em>*</em>
                    <select id="ddlLanguageList" class="form-control" multiple>
                      <option *ngFor="let item of languageList" value={{item.ID}}>
                        {{item.Language}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    Interest<em>*</em>
                    <select id="ddlInterestList" class="form-control" multiple>
                      <option *ngFor="let item of interestList" value={{item.ID}}>
                        {{item.Subject}}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-6">
                    Restriction<em>*</em>
                    <select id="ddlRestrictionList" class="form-control" multiple>
                      <option *ngFor="let item of restrictionList" value={{item.ID}}>
                        {{item.Subject}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-6 " id="fileupload">
                  Upload Updated Resume<em>*</em>
                  <input id="doc_file" type="file" class="form-control" (change)="onFileSelected($event)">
                  <strong>File size must be 50KB :('doc', 'docx', 'pdf')</strong>
                </div>
                Modal footer
                <div class="modal-footer" id="footer">

                  <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="ClearData()">Reset</button>
                  <button type="submit" (click)="AddFreelancer()" class="btn btn-outline-success waves-effect waves-light">Register</button>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>-->
